import { Badge } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { GridContainer, GridItem, GridItems, GridTitle } from './styles';

const sortAlphaNum = (a, b) => parseInt(a.name.replaceAll(/[A-Z]+/gi, '')) - parseInt(b.name.replaceAll(/[A-Z]+/gi, '')) || a.name.localeCompare(b.name); //eslint-disable-line

export default function GridBox({ locationGroup, locationList }) {
  const sortedLocationList = locationGroup === 'Skid' ? locationList : locationList.sort(sortAlphaNum);
  return (
    <GridContainer>
      <GridTitle>{locationGroup}</GridTitle>
      <GridItems>
        {sortedLocationList
          // .sort(sortAlphaNum)
          .map((location) =>
            location.location_parent_id !== null ? (
              <div key={location.id}>
                <Link to={`/locationInventory/${location.location_parent_id}`}>{location.name}</Link>
              </div>
            ) : location.group === 'Skid' ? (
              <GridItem key={location.id} empty={Boolean(location.quantity === 0)}>
                <Badge
                  color={location.quantity > 0 ? '#1890ff' : 'gray'}
                  count={location.quantity}
                  showZero
                  overflowCount={9999}
                  style={{ zIndex: 999 }}
                  offset={[-15]}
                  size="small"
                >
                  <div>
                    <Link to={`/locationInventory/${location.id}`}>{location.name}</Link>
                  </div>
                </Badge>
              </GridItem>
            ) : (
              <GridItem key={location.id} empty={Boolean(location.quantity === 0)}>
                <div>
                  <Link to={`/locationInventory/${location.id}`}>{location.name}</Link>
                </div>
              </GridItem>
            )
          )}
      </GridItems>
    </GridContainer>
  );
}
